import React, {Component} from "react";
import {connect} from "react-redux";
import FJLocalStore from "../../../store/FJLocalStore";
import FJDropDown from "fj-components/FJDropDown";
import FJButton from "fj-components/FJButton";
import FJToolbarButton from "./FJToolbarButton";
import styles from './FJTransform.module.less';
import leftIcon from '../../../icon/left_icon.svg';
import rightIcon from '../../../icon/right_icon.svg';
import horizontallyIcon from '../../../icon/horizontally.svg';
import verticallyIcon from '../../../icon/vertically.svg';
import InlineSVG from "react-inlinesvg";
import FJActionConstant from "../../../constant/FJActionConstant";
import FJToolbarAction from "../../../redux/action/FJToolbar.action";

function FJMediaDropDownItem(props) {
  let {label, icons, texts, onClicks} = props;
  return (
    <>
      <label className={styles.label_text}>{label}</label>
      <div className={styles.button_inner}>
        <div className={styles.button} onClick={onClicks[0]}>
          <InlineSVG src={icons[0]} />
          <span className={styles.text}>{texts[0]}</span>
        </div>
        <div className={styles.button} onClick={onClicks[1]}>
          <InlineSVG src={icons[1]} />
          <span className={styles.text}>{texts[1]}</span>
        </div>
      </div>
    </>
  );
}

function FJMediaDropDownContent(props) {
  const {onClick} = props;
  const leftClick = () => {onClick(FJActionConstant.ROTATE_LEFT)};
  const rightClick = () => {onClick(FJActionConstant.ROTATE_RIGHT)};
  const horizontalClick = () => {onClick(FJActionConstant.FLIP_HORIZONTALLY)};
  const verticalClick = () => {onClick(FJActionConstant.FLIP_VERTICALLY)};
	return (
		<>
      <FJMediaDropDownItem label={FJLocalStore._('rotate')}
                           icons={[leftIcon, rightIcon]}
                           texts={[FJLocalStore._('left'), FJLocalStore._('right')]}
                           onClicks={[leftClick, rightClick]}
      />
      <FJMediaDropDownItem label={FJLocalStore._('flip')}
                           icons={[horizontallyIcon, verticallyIcon]}
                           texts={[FJLocalStore._('horizontally'), FJLocalStore._('vertically')]}
                           onClicks={[horizontalClick, verticalClick]}
      />
		</>
	)
}

function FJElementDropDownContent(props) {
	return (
		<>
			<FJButton text={FJLocalStore._('horizontally')}
								type='default'
								icon={horizontallyIcon}
								className={styles.list}
								textClass={styles.list_text}
								iconClass={styles.icon}
								onClick={() => {
									props.onClick(FJActionConstant.FLIP_HORIZONTALLY)
								}}
			/>
			<FJButton text={FJLocalStore._('vertically')}
								type='default'
								icon={verticallyIcon}
								className={styles.list}
								textClass={styles.list_text}
								iconClass={styles.icon}
								onClick={() => {
									props.onClick(FJActionConstant.FLIP_VERTICALLY)
								}}
			/>
		</>
	)
}

class FJTransform extends Component{

	/**
	 * @description 视频 图片旋转
	 * @returns {*}
	 */
	returnMediaContent = () => {

		let {
			disabled,
			transformChange
		} = this.props

		return (
			<FJDropDown overlay={
				<div className={styles.transform_container}>
					<FJMediaDropDownContent onClick={transformChange}/>
				</div>
			}
                  useAnchorBody
                  isTopLayer
									canTriggerActive
									hasArrow={true}
			>
				<FJToolbarButton disabled={disabled} style={{float: 'left'}} text={FJLocalStore._('transform')} />
			</FJDropDown>
		)
	}

	/**
	 * @description 小组件旋转
	 * @returns {*}
	 */
	returnElementContent = () => {
		let {
			disabled,
			transformChange
		} = this.props

		return (
			<FJDropDown overlay={
				<div className={styles.element_transform_container}>
					<FJElementDropDownContent onClick={transformChange}/>
				</div>
			}
									canTriggerActive
                  useAnchorBody
                  isTopLayer
									hasArrow={true}
			>
				<FJToolbarButton disabled={disabled} style={{float: 'left'}} text={FJLocalStore._('flip')} />
			</FJDropDown>
		)
	}

	getContent = () => {
		let {
			type
		} = this.props
		switch (type) {
			case 'media': return this.returnMediaContent();
			case 'element': return this.returnElementContent();
			default:
		}
	}

	render() {
		return this.getContent();
	}

}

const maoDispatchToProps = function (dispatch) {
	return {
		transformChange: function (type) {
			dispatch(FJToolbarAction.transformChangeAction(type))
		}
	}
}

export default connect(null, maoDispatchToProps)(FJTransform);
